// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GiftFilledSvg from "@fishx/icons-svg/es/asn/GiftFilled";
import FishxIcon from '../components/FishxIcon';

var GiftFilled = function GiftFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GiftFilledSvg
  }));
};

GiftFilled.displayName = 'GiftFilled';
export default React.forwardRef(GiftFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GiftFilled.js
// module id = 2868
// module chunks = 0